import { define, type, auto, Record } from 'type-r'
import { store } from '../models/store.js'

@define
export default class Modal extends Record {
    @auto(null) declare myWin: any;

    initialize() {
        this.listenTo(store, "change:sendmodal", this.openLoadingModal);
    }
    
    openLoadingModal(): void {
        const self = this;

        this.myWin = $.modal({
            contentAlign: 'center',
            width: 400,
            title: 'Warning',
            content: $('#modal-content').html(),
            buttons: {
                'Click Here to View Free Data': {
                    classes: 'glossy',
                    click: (win) => win.closeModal()
                }
            },
            scrolling: true,
            actions: {
            },
            onOpen: function () {
                self.myWin = this;
            }
        });
    }
}

